export const STORYBLOK_MANYPETS_FOLDER_SLUG = 'manypets'
